'use client';

import { algoliasearch, SearchClient } from 'algoliasearch';

// EWM-253 — browser search client built from the per-dealer SECURED API
// key (minted server-side, delivered via AlgoliaKeyProvider). The raw
// parent search key no longer ships to the browser — only this scoped,
// signed key does, so the dealer-catalog filter is tamper-proof.
//
// `appId` stays public (`NEXT_PUBLIC_ALGOLIA_APP_ID`); app IDs aren't
// secret. When no secured key is available (mint unconfigured, or a
// surface like preview that doesn't inject one) we return a no-op client
// — search is disabled, never bypassed.
let cachedClient: SearchClient | null = null;
let cachedKey: string | undefined;

const noOpClient = {
  search: async () => ({ results: [{ hits: [], nbHits: 0, hitsPerPage: 0, page: 0, nbPages: 0 }] }),
} as unknown as SearchClient;

export const getAlgoliaSearchClient = (securedApiKey?: string): SearchClient => {
  const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID;

  if (!appId || !securedApiKey) {
    if (process.env.NODE_ENV === 'development') {
      console.error(
        '[algolia] NEXT_PUBLIC_ALGOLIA_APP_ID + a minted secured key are required. ' +
          'Search is disabled until both are present.',
      );
    }
    return noOpClient;
  }

  // Re-mint (e.g. BU/store change) yields a new key — rebuild the client.
  if (cachedClient && cachedKey === securedApiKey) return cachedClient;
  cachedKey = securedApiKey;
  cachedClient = algoliasearch(appId, securedApiKey);
  return cachedClient;
};
